<template>
  <div class="w-100 bg-white fit-to-screen pb-5">
    <div v-if="is_load" class="w-100 text-center py-5">
      <loader />
    </div>
    <template v-else>
      <div class="w-100 py-5 px-4" v-if="error != ''">
        <ErrorMessage :message="error" />
      </div>
      <template v-else>
        <span id="top-section"></span>
        <template v-if="data.status == 'SUCCESS'">
          <div class="w-100 px-4 pb-5" ref="success_section">
            <div class="w-100 text-center top-section-wrapper">
              <img src="../../assets/img/icon/new-success.png" width="150">
            </div>
            <div class="w-85 mx-auto text-center mb-3">
              <p class="mb-0 heading-5-1 text-32 text-success">Success!</p>
              <!-- <p class="mb-3 body-1-2">Hey {{ guest_profile.name }}, your payment has been successful!</p> -->
            </div>
            <div class="w-100 d-flex border-form box-shadow-light-aff p-3 radius-6 bg-white mb-4">
              <div class="img-merchant mr-3">
                <img :src="getMerchant.image_url">
              </div>
              <div class="w-100">
                <p class="body-1-4 mb-0">{{ getMerchant.name }}</p>
                <p class="body-3-3 mb-0" v-if="$isNotEmpty(getMerchant.phone)">{{ getMerchant.phone }}</p>
                <p class="body-3 mb-0">{{ getMerchant.address }}</p>
              </div>
            </div>
            <div class="w-100 border-form box-shadow-light-aff p-3 radius-6 bg-white mb-4">
              <div class="d-flex align-items-center border-b-form pb-3">
                <div class="room-icon">
                  <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.90586 17.9786H1.54529C2.08881 17.9786 2.45115 17.627 2.45115 17.0728V15.4956C2.56838 15.5275 2.92007 15.5489 3.17584 15.5489H23.8294C24.0852 15.5489 24.4369 15.5275 24.5541 15.4956V17.0728C24.5541 17.627 24.9164 17.9786 25.46 17.9786H26.0994C26.6536 17.9786 27.0053 17.627 27.0053 17.0728V9.77264C27.0053 7.73711 25.897 6.63942 23.8614 6.63942H3.14387C1.10835 6.63942 0 7.73711 0 9.77264V17.0728C0 17.627 0.351687 17.9786 0.90586 17.9786ZM2.13144 13.9929C1.90764 13.9929 1.76909 13.833 1.76909 13.5773V9.52755C1.76909 8.71757 2.30195 8.19537 3.13321 8.19537H23.8827C24.7034 8.19537 25.2362 8.71757 25.2362 9.52755V13.5773C25.2362 13.833 25.0977 13.9929 24.8739 13.9929H2.13144ZM2.77087 6.86323H5.57371V4.66784C5.57371 3.67673 6.12788 3.13321 7.14031 3.13321H10.8809C11.8827 3.13321 12.4369 3.67673 12.4369 4.66784V6.86323H14.5683V4.66784C14.5683 3.67673 15.1225 3.13321 16.1243 3.13321H19.865C20.8774 3.13321 21.4316 3.67673 21.4316 4.66784V6.86323H24.2344V2.98401C24.2344 1.01243 23.1794 0 21.2611 0H5.74422C3.83658 0 2.77087 1.01243 2.77087 2.98401V6.86323Z"
                      fill="white" />
                  </svg>
                </div>
                <div class="w-70 px-3">
                  <p class="body-1-4 mb-0">{{ reservation.room_type.name }}</p>
                  <p class="body-3 mb-0">{{ reservation.room.name }}</p>
                </div>
                <div class="w-30 pr-3 text-right">
                  <p class="body-1-4 mb-0 text-green">#{{ reservation.folio_number }}</p>
                  <p class="body-3 mb-0">Folio Number</p>
                </div>
              </div>
              <div class="w-100 d-flex align-items-center">
                <div class="w-40 border-r-form pt-3">
                  <p class="mb-0 body-2-4">{{ guest_profile.name }}</p>
                  <p class="mb-0 body-3">Guest Name</p>
                </div>
                <div class="w-30 text-center pt-3">
                  <p class="mb-0 body-2-4 text-green">{{ $formatDate(reservation.arrival_date,'YYYY-MM-DD') }}</p>
                  <p class="mb-0 body-3">Checkin</p>
                </div>
                <div class="w-30 text-center pt-3">
                  <p class="mb-0 body-2-4 text-danger">{{ $formatDate(reservation.departure_date,'YYYY-MM-DD') }}</p>
                  <p class="mb-0 body-3">Checkout</p>
                </div>
              </div>
            </div>
            <div class="w-100 border-form box-shadow-light-aff px-3 radius-6 bg-white">
              <div class="d-flex align-items-center justify-content-between py-3 border-b-form-dashed-2">
                <p class="body-3 mb-0 mr-3">Reference ID</p>
                <p class="body-3-3-2 mb-0 text-right">{{ data.reference_id }}</p>
              </div>
              <div class="d-flex align-items-center justify-content-between py-3 border-b-form-dashed-2">
                <p class="body-3 mb-0 mr-3">Payment Method</p>
                <p class="body-3-3-2 mb-0 text-right">{{ payment.payment_name }}</p>
              </div>
              <div class="d-flex align-items-center justify-content-between py-3 border-b-form-dashed-2">
                <p class="body-3 mb-0 mr-3">Status</p>
                <p class="body-3-3-2 mb-0 text-uppercase text-right" :class="data.status == 'SUCCESS'? 'text-success' : 'text-danger'">{{data.status}}</p>
              </div>
              <div class="d-flex align-items-center justify-content-between py-3 border-b-form-dashed-2">
                <p class="body-3 mb-0 mr-3">Date</p>
                <p class="body-3-3-2 mb-0 text-right">{{ $formatDateTime(data.created_at) }}</p>
              </div>
              <div v-if="Number(data.payment_surcharge) > 0" class="d-flex align-items-center justify-content-between py-3 border-b-form-dashed-2">
                <p class="body-3 mb-0 mr-3">Payment Surcharge</p>
                <p class="body-3-3-2 mb-0 text-right">{{ $formatCurrency(data.payment_surcharge) }}</p>
              </div>
              <div class="d-flex align-items-center justify-content-between py-3">
                <p class="body-3 mb-0 mr-3">Total Paid</p>
                <p class="body-3-3-2 mb-0 text-right">{{ $formatCurrency(data.total_bill) }}</p>
              </div>
            </div>
          </div>
          <div class="d-table mx-auto">
            <state-button :click="captureAndDownload" variant="secondary-outline" size="md">Download Invoice</state-button>
          </div>
        </template>
        <div class="w-100 px-4 py-5" v-else-if="data.status == 'UNPAID'">
          <VirtualAccount
            v-if="payment.payment_method == 'VIRTUAL_ACCOUNT'"
            :data="payment.detail"
            module_page="HOTEL_RESERVATION"
            :customer_detail="guest_profile" />

          <Qris 
            v-if="payment.payment_method == 'QRIS'"
            :data="payment.detail"
            module_page="HOTEL_RESERVATION"
            :customer_detail="guest_profile" />

          <div class="w-100 text-center">
            <p class="body-2-4 mb-3">{{$t("hotel.waiting.already-made-a-payment")}}</p>
            <state-button variant="primary" size="lg" :click="checkStatus">{{$t("hotel.waiting.check-payment-status")}}</state-button>
            <p class="body-2-4 text-danger mb-0 mt-2" v-if="payment_still_not_complete">{{$t("hotel.waiting.payment-still-not-processed")}}</p>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';
  import {
    get
  } from '@/services/index.js'
  import VirtualAccount from '@/components/general/payment/VirtualAccount'
	import Qris from '@/components/general/payment/Qris'
  
  export default {
    components:{
      VirtualAccount,
      Qris
    },
    data() {
      return {
        is_load: true,
        error: '',
        data: {},
        reservation: {},
        payment_method: {},
        payment: {},
        payment_still_not_complete: false
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      ga_reservation_id(){
        let id = this.$route.params.ga_reservation_id
        if(id) return id
        return ''
      },
      tx_payment_id(){
        let id = this.$route.params.tx_payment_id
        if(id) return id
        return ''
      },
      guest_profile(){
        let data = this.$isNotEmpty(this.reservation.guest_profile) ? this.reservation.guest_profile : this.reservation.folio.booked_by
        data.first_name = data.name
        data.phone_number = data.phone
        return data 
      },
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      loadFirstData(){
        this.is_load = true
        this.error = ''
        Promise.all([
          this.loadTrxDetailFromAPI(),
          this.loadDetailReservation()
        ])
        .then(()=>{
          this.getDetailPayment()
        })
        .catch(err=>{
          this.error = err
        })
        .finally(()=>{
          this.is_load = false
          setTimeout(() => {
            this.$smoothScroll('top-section')
          }, 100);
        })
      },
      loadTrxDetailFromAPI(){
				return new Promise((success,fail)=>{
          let url = `tx-guest-bill-detail/${this.ga_reservation_id}/${this.tx_payment_id}`
					get("CONCIERGE",url).then(response=>{
						let res = response.data
						if(res.success){
              this.data = res.data
              this.data.inq_resp_detail = JSON.parse(this.data.inq_resp_detail)
              this.data.payment_surcharge = Number(this.data.payment_surcharge)
							success()
						}else{
							fail(res.message)
						}
					})
				})
			},
      loadDetailReservation(){
        return new Promise((success,fail)=>{
          get("CONCIERGE",`reservation/${this.ga_reservation_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.reservation = res.data
              if(!this.$isNotEmpty(res.data.room_type)){
                this.reservation.room_type= {}
                this.reservation.room_type.name = 'Unallocated Room Type'
              }
              if(!this.$isNotEmpty(res.data.room)){
                this.reservation.room = {}
                this.reservation.room.name = 'Unallocated Room'
              }
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      loadPaymentList(){
        return new Promise((success,fail)=>{
          get("CONCIERGE",`merchant-payment/${this.getMerchant.id}`).then(response=>{
            let res = response.data
            if(res.success){
              this.reservation = res.data
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      checkStatus(){
        return new Promise((success,fail)=>{
          this.payment_still_not_complete = false
          this.loadTrxDetailFromAPI()
          .then(()=>{
            let payment_status = this.data.status
            if(payment_status === 'UNPAID' || payment_status === 'PENDING') this.payment_still_not_complete = true
            else {
              this.getDetailPayment()
              setTimeout(() => {
                this.$smoothScroll('top-section')
              }, 100);
            }
          })
          .finally(()=>success())
        })
      },
      getDetailPayment(){
        let clone_data = this.$deepCopy(this.data)
        this.payment = {
          status: clone_data.status,
          bank_name: clone_data.payment_channel.payment_gateway.pg_company,
          payment_method: clone_data.payment_channel.channel,
          payment_name: clone_data.payment_channel.name,
          pg_response: clone_data.inq_resp_detail,
          created_at: clone_data.created_at,
          detail: clone_data,
          payment_detail_error: clone_data.pay_resp_detail
        }
			},
      captureAndDownload(){
      	return new Promise((success,fail)=>{
					let file_name = `${this.getMerchant.name} - Payment.png`
					this.$domToImg(this.$refs.success_section, file_name).finally(()=>{
						success()
					})
      	})
      }
    }
  }
</script>
<style>
  .img-check{
    height: 100px;    
  }
  @media screen and (max-width: 400px){
    .img-check{
      height: 60px;    
    }
  }
  .top-section-wrapper{
    height: 200px;
    display: grid;
    place-items: center;
  }
  .room-icon{
    width: 70px;
    height: 50px;
    background-color: var(--merchant-primary-color);
    border-radius: 6px;
    display: grid;
    place-items: center;
    flex-shrink: 0;
  }
  .img-merchant{
    width: 80px;
    height: 80px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
  }
  .img-merchant img{
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/pages/hotel/PaymentBillResult.vue